<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--category">
                <span>Partners</span>
            </h1>
        </div>

        <div
            class="row referral-invoices-filter filter partner-invoice--filter"
        >
            <form method="get">
                <div class="form-field form-field__select">
                    <label for="partner">Partner</label>
                    <v-select
                        label="name"
                        :options="
                            items.map((item) => {
                                return {
                                    name: item.name.name,
                                    id: item.id,
                                };
                            })
                        "
                        @input="changePartnerSelect"
                    >
                    </v-select>
                </div>
                <div class="form-field form-field__select">
                    <label for="brand">Brand</label>
                    <v-select
                        label="name"
                        :options="brands"
                        @input="changeBrandSelect"
                    >
                    </v-select>
                </div>

                <div class="group-filter group-filter--status">
                    <!-- <div class="checkbox">
                    <div
                        class="form-field checkbox-wrap"
                        v-for="filter in statuses"
                        :key="filter.id"
                    >
                        <input
                            type="checkbox"
                            :id="`filter_status_${filter.id}`"
                            :value="filter.id"
                            @change="checkboxValue"
                            name="status[]"
                        />
                        <label :for="`filter_status_${filter.id}`"
                            ><i class="icon icon-checkmark"></i
                        ></label>
                        {{ filter.name }}
                    </div>
                </div> -->
                </div>
            </form>
            <div class="form-field form-field--button form-field--button-new">
                <a href="/partners/create" class="btn btn--gray">
                    <i class="icon icon-plus"></i>Add partner</a
                >
                <button
                    @click="openColumnsModal"
                    type="button"
                    class="btn btn--gray"
                >
                    Edit column view
                </button>
            </div>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>

        <div class="row master-invoices-table">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                {{ col_obj.name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="9">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="9"><center>No data</center></td>
                        </tr>
                        <tr
                            v-else-if="
                                (selectedPartner || selectedBrand) &&
                                filterItems.length
                            "
                            v-for="item in filterItems"
                            :key="item.id"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                        <tr
                            v-else-if="
                                (selectedPartner || selectedBrand) &&
                                !filterItems.length
                            "
                        >
                            <td colspan="9"><center>No data</center></td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.id">
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row master-invoices-pagination jus-c--right"></div>

        <!-- Columns modal -->
        <div
            class="modal modal-open"
            id="modal-columns-edit"
            v-if="showModalColumns"
        >
            <div class="modal-overflow">
                <div class="modal-window">
                    <button class="btn btn-modal-close" @click="closeModal">
                        <i class="icon icon-cancel"></i>
                    </button>
                    <div class="modal-body">
                        <div class="columns-list-wrap">
                            <div class="columns-list-col">
                                <div class="columns-list-col-title">
                                    Available columns
                                </div>
                                <div class="columns-datalist">
                                    <div
                                        v-for="item in hiddenItems"
                                        v-bind:key="'col_left_' + item.id"
                                        class="columns-datalist-item"
                                        @click="selectColumn(item)"
                                        :class="
                                            selected_col &&
                                            selected_col.id === item.id &&
                                            'selected'
                                        "
                                    >
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>

                            <div class="columns-datalist-controls">
                                <button
                                    :disabled="
                                        selected_col === null ||
                                        !selected_col.status === 'show'
                                    "
                                    class="btn btn--icon btn--col-left"
                                    @click="moveToHidden"
                                >
                                    <i class="icon icon-left-arrow"></i>
                                </button>
                                <button
                                    :disabled="
                                        selected_col === null ||
                                        !selected_col.status === 'hidden'
                                    "
                                    class="btn btn--icon btn--col-right"
                                    @click="moveToShow"
                                >
                                    <i class="icon icon-left-arrow"></i>
                                </button>
                            </div>
                            <div class="columns-list-col">
                                <div class="columns-list-col-title">
                                    Visible columns
                                </div>
                                <div class="columns-datalist">
                                    <div
                                        class="columns-datalist-item"
                                        v-for="item in showItems"
                                        v-bind:key="'col_right_' + item.id"
                                        @click="selectColumn(item)"
                                        :class="
                                            selected_col &&
                                            selected_col.id === item.id &&
                                            'selected'
                                        "
                                    >
                                        {{ item.name }} ({{ item.position }})
                                    </div>
                                </div>
                            </div>

                            <div class="columns-datalist-controls">
                                <button
                                    :disabled="isHiddenItem"
                                    class="btn btn--icon btn--col-up"
                                    @click="changePositionToUp"
                                >
                                    <i class="icon icon-down-arrow"></i>
                                </button>
                                <button
                                    :disabled="isHiddenItem"
                                    class="btn btn--icon btn--col-down"
                                    @click="changePositionToDown"
                                >
                                    <i class="icon icon-down-arrow"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END Columns modal -->
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";

export default {
    name: "Referral_Partners",
    props: ["brands", "columns"],
    components: {
        ClipLoader,
    },
    data() {
        return {
            selectedPartner: null,
            selectedBrand: null,
            loading: false,
            items: [],
            filterItems: [],
            descending: true,
            lastSort: "name",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        this.fetchData();
    },

    computed: {
        hiddenItems() {
            if (!this.filter_columns.length) {
                return [];
            }

            return this.filter_columns.filter(
                (item) => item.status === "hidden"
            );
        },
        showItems() {
            try {
                if (!this.filter_columns.length) {
                    return [];
                }

                return this.filter_columns
                    .filter((item) => item.status === "show")
                    .sort((a, b) => a.position - b.position);
            } catch (err) {
                console.error("showItems error", err);
            }
        },
        isHiddenItem() {
            if (this.selected_col) {
                return this.selected_col.status === "hidden";
            }
            return true;
        },
    },

    methods: {
        changePartnerSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedPartner = id;
                this.filterPartnerData(id);
            } else {
                this.selectedPartner = null;
                this.filterItems = [];
            }
        },

        changeBrandSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedBrand = id;
                this.filterByBrandsData(id);
            } else {
                this.selectedBrand = null;
                this.filterItems = [];
            }
        },

        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        deletePartner(id) {
            if (window.confirm("This action cannot be undone, are you sure?")) {
                this.loading = true;

                axios
                    .post("/partners/delete", {
                        id: id,
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.data.isSuccess) {
                            this.fetchData();
                            this.selectedPartner = null;
                            this.selectedBrand = null;
                            this.filterItems = [];
                        }
                    })
                    .catch((err) => {
                        console.error("Delete partner error", err);
                        this.loading = false;
                    });
            }
        },
        fetchData() {
            this.loading = true;

            axios
                .post("/partners/getList")
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    console.error("Fetch partners error", err);
                    this.loading = false;
                });
        },
        filterPartnerData(id = null) {
            const filterBrand = this.selectedBrand;

            const filterArrByPartner = this.items.filter((item) => {
                return item.id == id;
            });

            console.log(filterArrByPartner);

            if (filterBrand) {
                this.filterItems = filterArrByPartner.filter((item) => {
                    return item.brands.some((brand) => brand == filterBrand);
                });
            } else {
                this.filterItems = filterArrByPartner;
            }
        },
        filterByBrandsData(id = null) {
            const filterPartner = this.selectedPartner;

            const filterArrByBrand = this.items.filter((item) => {
                return item.brands.some((brand) => brand == id);
            });

            if (filterPartner) {
                this.filterItems = filterArrByBrand.filter((item) => {
                    return item.id == filterPartner;
                });
            } else {
                this.filterItems = filterArrByBrand;
            }
        },
        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "id":
                    self.items = self.items.sort(
                        sortArray.sortNumber("id", self.descending)
                    );
                    break;
                case "name":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "name",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "deals":
                    self.items = self.items.sort(
                        sortArray.sortText("deals", self.descending)
                    );
                    break;
                case "invoiced":
                    self.items = self.items.sort(
                        sortArray.sortText("invoiced", self.descending)
                    );
                    break;
                case "commission_payable":
                    self.items = self.items.sort(
                        sortArray.sortNumber(
                            "commission_payable",
                            self.descending
                        )
                    );
                    break;
            }
            self.descending = !self.descending;
        },

        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    if (c.slug === "deals") {
                                        tempObj[`${c.slug}`] =
                                            item.year_deals +
                                            "(" +
                                            item.total_deals +
                                            ")";
                                        return;
                                    }
                                    if (c.slug === "invoiced") {
                                        tempObj[`${c.slug}`] =
                                            item.year_brands +
                                            "(" +
                                            item.total_brands +
                                            ")";
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];
                                    tempObj["brands"] = item["brands"];
                                });

                            newFormatData.push(tempObj);
                            console.log("newFormatData", newFormatData);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            this.filter_columns = JSON.parse(
                JSON.stringify(this.current_columns)
            );
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal() {
            await axios
                .post("/partners/updateColumns", {
                    columns: this.filter_columns,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(
                        JSON.stringify(this.filter_columns)
                    );
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
        moveToHidden() {
            this.filter_columns = this.filter_columns.map((col) => {
                if (col.id === this.selected_col.id) {
                    col.status = "hidden";
                    return col;
                }
                return col;
            });
        },
        moveToShow() {
            this.filter_columns = this.filter_columns.map((col) => {
                if (col.id === this.selected_col.id) {
                    col.status = "show";
                    return col;
                }
                return col;
            });
        },

        changePositionToUp() {
            const _index = this.filter_columns.findIndex(
                (item) => item.id === this.selected_col.id
            );

            if (_index !== 0) {
                let el = this.filter_columns[_index];
                this.filter_columns[_index] = this.filter_columns[_index - 1];
                this.filter_columns[_index - 1] = el;

                const showItems = this.filter_columns.filter(
                    (item) => item.status === "show"
                );
                const hiddenItems = this.filter_columns.filter(
                    (item) => item.status === "hidden"
                );

                this.filter_columns.length = 0;
                this.filter_columns = [...showItems, ...hiddenItems];
                this.filter_columns.forEach((i, index) => {
                    i.position = index + 1;
                });
            }
        },

        changePositionToDown() {
            const _index = this.filter_columns.findIndex(
                (item) => item.id === this.selected_col.id
            );

            if (_index !== -1 && _index < this.filter_columns.length - 1) {
                let el = this.filter_columns[_index];
                this.filter_columns[_index] = this.filter_columns[_index + 1];
                this.filter_columns[_index + 1] = el;

                // this.filter_columns.forEach((i, index) => {
                //     i.position = index + 1;
                // });

                const showItems = this.filter_columns.filter(
                    (item) => item.status === "show"
                );
                const hiddenItems = this.filter_columns.filter(
                    (item) => item.status === "hidden"
                );

                this.filter_columns.length = 0;
                this.filter_columns = [...showItems, ...hiddenItems];
                this.filter_columns.forEach((i, index) => {
                    i.position = index + 1;
                });
            }
        },
    },
};
</script>
